const SIDE_DATA = "SIDE_DATA";

const state = {
  sideData: null,
};

const getters = {
  sideData: state => state.sideData,
};

const actions = {
  setSideData({dispatch, commit}, payload) {
    commit(SIDE_DATA, payload);
  },
};

const mutations = {
  [SIDE_DATA](state, payload) {
    state.sideData = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
